export function LoginBackground() {
    return (
        <div id="loginBackground" className="position-absolute end-0 w-50 d-none d-xl-block text-center">
            <img className="img-fluid position-absolute top-50 translate-middle mb-5" src="/login/images/login.svg" alt="Login background illustration" />
        </div>
    );
}